import { Router } from '@angular/router';
import { NewPaymentRequest, PaymentList, PaymentSearch, PaymentRightsProperties } from '../Models/PaymentProperties';
import { PaymentService } from '../Services/payment.service';
import { Component } from '@angular/core';
import { ActiveDepositType, ActiveModeOfPayment } from '../Models/ActiveClasses';
@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
/** paymentList component*/
export class PaymentListComponent {
  paymentList: PaymentList[];

  modeOfPayments: ActiveModeOfPayment[] = [];
  modeOfPaymentsForAdd: ActiveModeOfPayment[] = [];
  paymentRequest = new NewPaymentRequest();
  rightsObj = new PaymentRightsProperties();
  immediateParent: string;
  setIntervalSetting: any;
  paymentSearch = new PaymentSearch();
  depositTypesList: ActiveDepositType[] | undefined;
  currentDate: any;
  startDate: any;
  paymentStatusList: object[] = [];
  loaderVar:boolean=false;
  constructor(private service: PaymentService, private router: Router) {
  }
  ngOnInit(): void {

    try {
      this.immediateParent = localStorage.getItem("ImmediateParent");
      this.paymentStatusList = [{ paymentStatus: "All" },{ paymentStatus: "Requested" }, { paymentStatus: "Approved" }, { paymentStatus: "Rejected" }]
      this.GetCurrentDate();
      this.CheckPaymentRights();
      this.LoadPaymentList();
      this.setIntervalSetting = setInterval(() => {
        this.LoadPaymentList();
      }, 120000);
      this.LoadBaseData();

    } catch (ex) { }
  }
  ngOnDestroy(): void {
    if (this.setIntervalSetting) {
      clearInterval(this.setIntervalSetting);
    }
  }
  private LoadBaseData = (): void => {
    try {
      this.service.getPaymentBaseData(localStorage.getItem("AgencyId")).subscribe((data) => {
        // ////console.log (data);
        this.depositTypesList = data.depositTypes;
        this.modeOfPaymentsForAdd=data.modeOfPayments;
        this.modeOfPaymentsForAdd=JSON.parse(JSON.stringify(this.modeOfPaymentsForAdd));
        this.modeOfPayments=data.modeOfPayments;
        let activeDeposits:ActiveDepositType= new ActiveDepositType();
        activeDeposits.depositTypeId=0;
        activeDeposits.depositTypeName="All";
        this.depositTypesList.unshift(activeDeposits);
        let mop:ActiveModeOfPayment= new ActiveModeOfPayment();
        mop.modeOfPaymentId=0;
        mop.modeOfPaymentName="All";
        this.modeOfPayments.splice(0,0,mop);
        if (this.immediateParent != null && this.immediateParent != "" && this.immediateParent != undefined) {
          if (this.immediateParent != "AG01") {
            const filterMode = this.modeOfPaymentsForAdd.filter(m => m.modeOfPaymentId != 4);
            this.modeOfPaymentsForAdd = filterMode;
          }
        }
      });
    } catch (ex) {
      ////////console.log (ex);
    }
  }
  private GetCurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;
    let startOfMonthDate = new Date(new Date().setDate(date.getDate() - 30));
    let startDate: any = startOfMonthDate.getDate();
    let startMonth: any = startOfMonthDate.getMonth() + 1;
    let startYear: any = startOfMonthDate.getFullYear();
    if (startDate < 10) {
      startDate = "0" + startDate;
    }
    if (startMonth < 10) {
      startMonth = "0" + startMonth;
    }
    this.startDate = startYear + "-" + startMonth + "-" + startDate;
    // ////console.log (this.startDate)
  }
  public SetRequestDateFrom = (date: any): void => {
    if (date.target.value == "") {
      this.paymentSearch.requestDateFrom = this.startDate;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.startDate;
      this.paymentSearch.requestDateFrom = this.startDate;
    }
    else {
      this.paymentSearch.requestDateFrom = date.target.value;
    }

  }
  public SetRequestDateTo = (date: any): void => {
    if (date.target.value == "") {
      this.paymentSearch.requestDateTo = undefined;
    }
    else if (new Date(date.target.value) > new Date(this.currentDate)) {
      date.target.value = this.currentDate;
      this.paymentSearch.requestDateTo = this.currentDate;
    }
    else {
      this.paymentSearch.requestDateTo = date.target.value;
    }
  }
  private LoadPaymentList = (): void => {
    try {
      this.paymentSearch.agencyId = localStorage.getItem('AgencyId');
      this.paymentSearch.userId = Number(localStorage.getItem('UserId'));
      this.paymentSearch.paymentStatus = null;
      this.paymentSearch.requestDateFrom = this.startDate;
      this.paymentSearch.requestDateTo = this.currentDate;
      this.paymentSearch.modeOfPayment = 0;
      this.paymentSearch.depositType = 0;
      this.service.getPaymentList(this.paymentSearch).subscribe((data) => {
        this.paymentList = data;
      });
    } catch (ex) {
      ////////console.log (ex);
    }
  }
  private CheckPaymentRights = (): void => {
    this.service.CheckPaymentRights(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
      this.rightsObj = data;
    });
  }
  public ManagePayments = (paymentId: number): void => {
    this.paymentRequest.paymentTypeId = paymentId;
    this.paymentRequest.paymentModeTypeId = 0;
    this.paymentRequest.newPaymentRequest = true;
    this.paymentRequest.paymentOpenFrom = "paymentList";
    this.service.SetRequestData(this.paymentRequest);
    this.router.navigateByUrl('/paymentAddEdit');
  }
  public AddNewPayment = (paymentId: number): void => {
    if (this.rightsObj.addPayment) {
      this.paymentRequest.paymentModeTypeId = paymentId;
      this.paymentRequest.paymentTypeId = 0;
      this.paymentRequest.newPaymentRequest = true;
      this.paymentRequest.paymentOpenFrom = "";
      this.service.SetRequestData(this.paymentRequest);
      this.router.navigateByUrl('/paymentAddEdit');
    }
    else {
      const paymenthead = document.getElementById("paymentHeadings");
      paymenthead.style.color = "red";
      paymenthead.innerHTML = "You Don't Have Rights!";
      setTimeout(() => {
        paymenthead.style.color = "var(--first-color-second)";
        paymenthead.innerHTML = "Payment List";
      }, 5000);
    }
  }
  public SubmitPaymentSearchForm = (paymentSearchForm:any): void => {
    this.loaderVar=true;
    this.paymentSearch.agencyId = localStorage.getItem('AgencyId');
    this.paymentSearch.userId = 0;
    if(this.paymentSearch.modeOfPayment==null || this.paymentSearch.modeOfPayment==undefined){
      this.paymentSearch.modeOfPayment=0;
    }
    if(this.paymentSearch.depositType==null || this.paymentSearch.modeOfPayment==undefined){
      this.paymentSearch.depositType=0;
    }
    this.service.getPaymentList(this.paymentSearch).subscribe((data) => {
      this.loaderVar=false;
      this.paymentList = data;
    });
  }

}
